const defaultColor = 0x4183c4

export const defaultViewerConfig = () => ({
  color: defaultColor
})
